import { TNotification } from "entities/notifications";
import { FC } from "react";
import { NotificationItem } from "./NotificationItem";
import { InView } from "react-intersection-observer";
import { NotificationsListTitle, NotificationsListWrapper } from "./styles";
import { COLORS } from "shared/consts";
import { useNotifications } from "../lib/useNotifications";

type NotificationsListProps = {
  notifications: TNotification[];
  isModal?: boolean;
  isVidget?: boolean;
  onInView?: (inView: boolean) => void;
};
export const NotificationsList: FC<NotificationsListProps> = ({
  notifications,
  isModal,
  isVidget,
  onInView,
}) => {
  const {
    onItemInView,
  } = useNotifications();

  if (!notifications.length)
    return (
      <NotificationsListWrapper $isModal={isModal} $isVidget={isVidget}>
        <NotificationsListTitle>
          <span>Уведомления отсутствуют</span>
        </NotificationsListTitle>
      </NotificationsListWrapper>
    );

  return (
    <NotificationsListWrapper $isModal={isModal} $isVidget={isVidget}>
      {isVidget && (
        <NotificationsListTitle>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.3788 16.5L16.7683 8.65106C16.5861 6.30819 14.6318 4.5 12.2819 4.5H11.7181C9.36818 4.5 7.41389 6.30819 7.23167 8.65105L6.6212 16.5L17.3788 16.5ZM5.73619 8.53474L5.11667 16.5L4 16.5V18L5 18H6.50453H8.12602C8.57006 19.7252 10.1362 21 12 21C13.8638 21 15.4299 19.7252 15.874 18H17.4955H19H20V16.5H18.8833L18.2638 8.53474C18.0208 5.41092 15.4151 3 12.2819 3H11.7181C8.58487 3 5.97915 5.41092 5.73619 8.53474ZM14.292 18L9.70802 18C10.0938 18.883 10.9748 19.5 12 19.5C13.0252 19.5 13.9062 18.883 14.292 18Z"
              fill={COLORS.FG.DEFAULT}
            />
          </svg>
          <span>Уведомления</span>
        </NotificationsListTitle>
      )}
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onItemInView={onItemInView}
        />
      ))}
      <InView as="div" style={{ padding: "2px" }} onChange={onInView} />
    </NotificationsListWrapper>
  );
};
